import Login from './SCBZ/Login';
import Logout from './SCBZ/Logout';
import EnterDrawTicket from './SCBZ/EnterDrawTicket';
import GetEntries from './SCBZ/GetEntries';
import GetPlayerData from './SCBZ/GetPlayerData';
import SetEntryFlashGameFlag from './SCBZ/SetEntryFlashGameFlag';

import Update from './FauxAPI/Update';
import Register from './FauxAPI/Register';
import Winners from './FauxAPI/Winners';
import PostFeedback from './FauxAPI/PostFeedback';
import ForgotPassword from './FauxAPI/ForgotPassword';
import GetGame from './FauxAPI/GetGame';
import GetGameOver from './FauxAPI/GetGameOver';
import GetAppVals from './FauxAPI/GetAppVals';

import LoginL2 from './Loyalty2/Login';
import LoginWithPTA from './Loyalty2/LoginWithPTA';
import PTALoginL2 from './Loyalty2/PTALogin';
import LogoutL2 from './Loyalty2/Logout';
import GetPlayerDataL2 from './Loyalty2/GetPlayerData';
import GetPlayerDataRam from './Loyalty2/GetPlayerDataRam';
import EnterTicketL2 from './Loyalty2/EnterTicket';
import CheckTicketL2 from './Loyalty2/CheckTicket';
import GetAchievements from './Loyalty2/GetAchievements';
import GetPoints from './Loyalty2/GetPoints';
import GetActivity from './Loyalty2/GetActivity';
import GetReward from './Loyalty2/GetReward';
import GetPromotions from './Loyalty2/GetPromotions';
import GetPlayerPromotions from './Loyalty2/GetPlayerPromotions';
import GetLotteryPromotions from './Loyalty2/GetLotteryPromotions';
import GetPlayerPFDTransactions from './Loyalty2/GetPlayerPFDTransactions';
import RedeemPFDPoints from './Loyalty2/RedeemPFDPoints';
import GetPointsForDrawings from './Loyalty2/GetPointsForDrawings';
import GetFeedbackCategories from './Loyalty2/GetFeedbackCategories';
import PostFeedbackL2 from './Loyalty2/PostFeedback';
import GetSweeps from './Loyalty2/GetSweeps';
import GetActiveSweeps from './Loyalty2/GetActiveSweeps';
import GetCurrentSweeps from './Loyalty2/GetCurrentSweeps';
import GetExpiredSweeps from './Loyalty2/GetExpiredSweeps';
import GetSweepDetails from './Loyalty2/GetSweepDetails';
import GetSweepDetailsByName from './Loyalty2/GetSweepDetailsByName';
import GetSweepsByName from './Loyalty2/GetSweepsByName';
import AllocateEntries from './Loyalty2/AllocateEntries';
import WinnersL2 from './Loyalty2/Winners';
import WinnersL2NoAuth from './Loyalty2/WinnersNoAuth';
import GetConfig from './Loyalty2/GetConfig';
import GetRevealToken from './Loyalty2/GetRevealToken';
import GetJackpotRoll from './Loyalty2/GetJackpotRoll';
import ExpiredDrawings from './Loyalty2/ExpiredDrawings';
import CTLExpiredDrawings from './Loyalty2/CTLExpiredDrawings';
import CurrentDrawings from './Loyalty2/CurrentDrawings';
import CTLCurrentDrawings from './Loyalty2/CTLCurrentDrawings';
import CTLVerify from './Loyalty2/CTLVerify';
import CTLForgotPassword from './Loyalty2/CTLForgotPassword';
import CTLRecoverPassword from './Loyalty2/CTLRecoverPassword';
import CTLUpdate from './Loyalty2/CTLUpdate';
import CTLRegister from './Loyalty2/CTLRegister';
import CTLConfirm from './Loyalty2/CTLConfirm';
import CTLConfirmResend from './Loyalty2/CTLConfirmResend';
import SCLConfirmResend from './Loyalty2/SCLConfirmResend';
import CTLBandog from './Loyalty2/CTLBandog';
import CTLEnterTicket from './Loyalty2/CTLEnterTicket';
import MRBRegister from './Loyalty2/MRBRegister';
import GetAllOptins from './Loyalty2/GetAllOptins';
import GetOptins from './Loyalty2/GetOptins';
import GetOptinsByCategory from './Loyalty2/GetOptinsByCategory';
import OptinSubscribe from './Loyalty2/OptinSubscribe';
import OptinUnsubscribe from './Loyalty2/OptinUnsubscribe';
import GetRafCode from './Loyalty2/GetRafCode';
import SendRafInvite from './Loyalty2/SendRafInvite';
import GetSurveyStatus from './Loyalty2/GetSurveyStatus';
import GetActiveSurveys from './Loyalty2/GetActiveSurveys';
import GetSurveyQuestions from './Loyalty2/GetSurveyQuestions';
import GetNamedSurveyQuestions from './Loyalty2/GetNamedSurveyQuestions';
import SetSurveyAnswer from './Loyalty2/SetSurveyAnswer';
import CompleteSurvey from './Loyalty2/CompleteSurvey';
import ActionComplete from './Loyalty2/ActionComplete';
import GetCoupons from './Loyalty2/GetCoupons';
import MRBCheckTicket from './Loyalty2/MRBCheckTicket';
import MRBEnterTicket from './Loyalty2/MRBEnterTicket';
import GetDashboard from './Loyalty2/GetDashboard';
import SubmitSocialMediaClick from './Loyalty2/SubmitSocialMediaClick';
import CompleteCustomUrlQualifier from './Loyalty2/CompleteCustomUrlQualifier';
import ClaimPromo from './Loyalty2/ClaimPromo';
import GetPlayerAllocatableEntries from './Loyalty2/GetPlayerAllocatableEntries';
import GetPlayerPrizes from './Loyalty2/GetPlayerPrizes';
import GetPlayerWinnings from './Loyalty2/GetPlayerWinnings';
import GetPointsHistory from './Loyalty2/GetPointsHistory';
import DeletePlayerAccount from './Loyalty2/DeletePlayerAccount';
import CallExternalEndpoint from './Loyalty2/CallExternalEndpoint';
import GetThirdPartyPrizes from './Loyalty2/GetThirdPartyPrizes';
import GetThirdPartyPrizeBarcode from './Loyalty2/GetThirdPartyPrizeBarcode';
import GetTicketActivity from './Loyalty2/GetTicketActivity';
import UpdateEmail from './Loyalty2/UpdateEmail';
import UpdatePassword from './Loyalty2/UpdatePassword';
import UpdateOptins from './Loyalty2/UpdateOptins';
import GetGameEngineGameBoards from './Loyalty2/GetGameEngineGameBoards';
import GetGameEngineGameBoard from './Loyalty2/GetGameEngineGameBoard';
import GetGameEngineGameWinTypesWithPrizes from './Loyalty2/GetGameEngineGameWinTypesWithPrizes';
import GetNotifications from './Loyalty2/GetNotifications';
import DismissAllNotifications from './Loyalty2/DismissAllNotifications';
import DismissNotification from './Loyalty2/DismissNotification';

/*
    In order to return a route here, include in the config object a callout for
    each route you intend to use, and the name of the available api call below.
    example config:
    {
        appUrl: "/jamesbondlotterychallenge",
        routes: {
            login: "scbzApi.login",
            logout: "scbzApi.logout",
            enterDrawTicket: "scbzApi.enterDrawTicket",
            getEntries: "scbzApi.getEntries",
            getPlayerData: "scbzApi.getPlayerData",
            setEntryFlashGameFlag: "scbzApi.setEntryFlashGameFlag",
            update: "fauxScbzApi.update",
            register: "fauxScbzApi.register",
            winners: "fauxScbzApi.winners",
            postFeedback: "fauxScbzApi.postFeedback",
            forgotPassword: "fauxScbzApi.forgotPassword",
            getGame: "fauxScbzApi.getGame",
            getGameOver: "fauxScbzApi.getGameOver",
        }
    }
*/

export default (config) => {
    const availableApis = {
        scbzApi: {
            login: Login(config),
            logout: Logout(config),
            enterDrawTicket: EnterDrawTicket(config),
            getEntries: GetEntries(config),
            getPlayerData: GetPlayerData(config),
            setEntryFlashGameFlag: SetEntryFlashGameFlag(config),
        },
        fauxScbzApi: {
            update: Update(config),
            register: Register(config),
            winners: Winners(config),
            postFeedback: PostFeedback(config),
            forgotPassword: ForgotPassword(config),
            getGame: GetGame(config),
            getGameOver: GetGameOver(config),
            getAppVals: GetAppVals(config),
        },
        loyalty2: {
            login: LoginL2(config),
            ptaLogin: PTALoginL2(config),
            getPlayerData: GetPlayerDataL2(config),
            getPlayerDataRam: GetPlayerDataRam(config),
            logout: LogoutL2(config),
            enterTicket: EnterTicketL2(config),
            checkTicket: CheckTicketL2(config),
            getAchievements: GetAchievements(config),
            getPoints: GetPoints(config),
            getActivity: GetActivity(config),
            getReward: GetReward(config),
            getPromotions: GetPromotions(config),
            getPlayerPromotions: GetPlayerPromotions(config),
            getPlayerPFDTransactions: GetPlayerPFDTransactions(config),
            redeemPFDPoints: RedeemPFDPoints(config),
            getPointsForDrawings: GetPointsForDrawings(config),
            getFeedbackCategories: GetFeedbackCategories(config),
            postFeedback: PostFeedbackL2(config),
            getNotifications: GetNotifications(config),
            dismissAllNotifications: DismissAllNotifications(config),
            dismissNotification: DismissNotification(config),
            getSweeps: GetSweeps(config),
            getSweepsByName: GetSweepsByName(config),
            getSweepDetailsByName: GetSweepDetailsByName(config),
            winners: WinnersL2(config),
            getConfig: GetConfig(config),
            getRevealToken: GetRevealToken(config),
            getJackpotRoll: GetJackpotRoll(config),
            actionComplete: ActionComplete(config),
            callExternalEndpoint: CallExternalEndpoint(config),
            deletePlayerAccount: DeletePlayerAccount(config),
            getGameEngineGameBoards: GetGameEngineGameBoards(config),
            getGameEngineGameBoard: GetGameEngineGameBoard(config),
            getGameEngineGameWinTypesWithPrizes: GetGameEngineGameWinTypesWithPrizes(config),
        },
        ctlEnsemble: {
            login: LoginL2(config),
            ptaLogin: PTALoginL2(config),
            update: CTLUpdate(config),
            register: CTLRegister(config),
            verify: CTLVerify(config),
            confirm: CTLConfirm(config),
            confirmResend: CTLConfirmResend(config),
            forgotPassword: CTLForgotPassword(config),
            recoverPassword: CTLRecoverPassword(config),
            getPlayerData: GetPlayerDataL2(config),
            logout: LogoutL2(config),
            enterTicket: CTLEnterTicket(config),
            checkTicket: CheckTicketL2(config),
            getAchievements: GetAchievements(config),
            getPoints: GetPoints(config),
            getActivity: GetActivity(config),
            getReward: GetReward(config),
            getPromotions: GetPromotions(config),
            getPlayerPromotions: GetPlayerPromotions(config),
            getFeedbackCategories: GetFeedbackCategories(config),
            postFeedback: PostFeedbackL2(config),
            getSweeps: GetSweeps(config),
            getSweepsByName: GetSweepsByName(config),
            getActiveSweeps: GetActiveSweeps(config),
            getSweepDetailsByName: GetSweepDetailsByName(config),
            getCurrentSweeps: GetCurrentSweeps(config),
            getExpiredSweeps: GetExpiredSweeps(config),
            winners: WinnersL2(config),
            winnersNoAuth: WinnersL2NoAuth(config),
            getConfig: GetConfig(config),
            getRevealToken: GetRevealToken(config),
            getJackpotRoll: GetJackpotRoll(config),
            getBanner: CTLBandog(config),
            expiredDrawings: ExpiredDrawings(config),
            currentDrawings: CurrentDrawings(config),
            recentDrawings: CTLExpiredDrawings(config),
            nextDrawings: CTLCurrentDrawings(config),
            getAllOptins: GetAllOptins(config),
            getOptins: GetOptins(config),
            optinSubscribe: OptinSubscribe(config),
            optinUnsubscribe: OptinUnsubscribe(config),
        },
        mrbEnsemble: {
            login: LoginL2(config),
            ptaLogin: PTALoginL2(config),
            update: CTLUpdate(config),
            register: MRBRegister(config),
            verify: CTLVerify(config),
            getPlayerData: GetPlayerDataL2(config),
            logout: LogoutL2(config),
            enterTicket: MRBEnterTicket(config),
            checkTicket: MRBCheckTicket(config),
            getAchievements: GetAchievements(config),
            getPoints: GetPoints(config),
            getActivity: GetActivity(config),
            getReward: GetReward(config),
            getCoupons: GetCoupons(config),
            getPromotions: GetPromotions(config),
            getPlayerPromotions: GetPlayerPromotions(config),
            getLotteryPromotions: GetLotteryPromotions(config),
            getFeedbackCategories: GetFeedbackCategories(config),
            postFeedback: PostFeedbackL2(config),
            getSweeps: GetSweeps(config),
            getSweepsByName: GetSweepsByName(config),
            getSweepDetailsByName: GetSweepDetailsByName(config),
            winners: WinnersL2(config),
            getConfig: GetConfig(config),
            getSweepDetails: GetSweepDetails(config),
            getSweepDetailsByName: GetSweepDetailsByName(config),
            allocateEntries: AllocateEntries(config),
            getRevealToken: GetRevealToken(config),
            getJackpotRoll: GetJackpotRoll(config),
            getBanner: CTLBandog(config),
            expiredDrawings: ExpiredDrawings(config),
            currentDrawings: CurrentDrawings(config),
            getAllOptins: GetAllOptins(config),
            getOptins: GetOptins(config),
            getOptinsByCategory: GetOptinsByCategory(config),
            optinSubscribe: OptinSubscribe(config),
            optinUnsubscribe: OptinUnsubscribe(config),
            sendRafInvite: SendRafInvite(config),
            getRafCode: GetRafCode(config),
            getActiveSurveys: GetActiveSurveys(config),
            getSurveyStatus: GetSurveyStatus(config),
            getSurveyQuestions: GetSurveyQuestions(config),
            getNamedSurveyQuestions: GetNamedSurveyQuestions(config),
            setSurveyAnswer: SetSurveyAnswer(config),
            completeSurvey: CompleteSurvey(config),
            getDashboard: GetDashboard(config),
            submitSocialMediaClick: SubmitSocialMediaClick(config),
            completeCustomUrlQualifier: CompleteCustomUrlQualifier(config),
            claimPromo: ClaimPromo(config),
            getPlayerAllocatableEntries: GetPlayerAllocatableEntries(config),
            getPlayerPrizes: GetPlayerPrizes(config),
            getPlayerWinnings: GetPlayerWinnings(config),
            getPointsHistory: GetPointsHistory(config),
            actionComplete: ActionComplete(config),
            callExternalEndpoint: CallExternalEndpoint(config),
            getThirdPartyPrizes: GetThirdPartyPrizes(config),
            getThirdPartyPrizeBarcode: GetThirdPartyPrizeBarcode(config),
            getTicketActivity: GetTicketActivity(config),
            updateEmail: UpdateEmail(config),
            updatePassword: UpdatePassword(config),
            updateOptins: UpdateOptins(config),
        },
        sclEnsemble: {
            login: LoginWithPTA(config),
            confirmResend: SCLConfirmResend(config),
        },
        resolve: (list, desc) => {
            if (desc) {
                var obj = { ...list };
                var arr = desc.split('.');
                while (arr.length && (obj = obj[arr.shift()]));
                return obj;
            } else {
                return undefined;
            }
        },
    };

    return {
        login: availableApis.resolve(availableApis, config.routes.login),
        logout: availableApis.resolve(availableApis, config.routes.logout),
        checkTicket: availableApis.resolve(availableApis, config.routes.checkTicket),
        enterIGT24Ticket: availableApis.resolve(availableApis, config.routes.enterIGT24Ticket),
        enterDrawTicket: availableApis.resolve(availableApis, config.routes.enterDrawTicket),
        enterScratchTicket: availableApis.resolve(availableApis, config.routes.enterScratchTicket),
        enterFastPlayTicket: availableApis.resolve(availableApis, config.routes.enterFastPlayTicket),
        getEntries: availableApis.resolve(availableApis, config.routes.getEntries),
        getPlayerData: availableApis.resolve(availableApis, config.routes.getPlayerData),
        getPlayerDataRam: availableApis.resolve(availableApis, config.routes.getPlayerDataRam),
        setEntryFlashGameFlag: availableApis.resolve(availableApis, config.routes.setEntryFlashGameFlag),
        update: availableApis.resolve(availableApis, config.routes.update),
        register: availableApis.resolve(availableApis, config.routes.register),
        verify: availableApis.resolve(availableApis, config.routes.verify),
        confirm: availableApis.resolve(availableApis, config.routes.confirm),
        confirmResend: availableApis.resolve(availableApis, config.routes.confirmResend),
        winners: availableApis.resolve(availableApis, config.routes.winners),
        getFeedbackCategories: availableApis.resolve(availableApis, config.routes.getFeedbackCategories),
        postFeedback: availableApis.resolve(availableApis, config.routes.postFeedback),
        forgotPassword: availableApis.resolve(availableApis, config.routes.forgotPassword),
        recoverPassword: availableApis.resolve(availableApis, config.routes.recoverPassword),
        getGame: availableApis.resolve(availableApis, config.routes.getGame),
        getGameOver: availableApis.resolve(availableApis, config.routes.getGameOver),
        getAchievements: availableApis.resolve(availableApis, config.routes.getAchievements),
        getPoints: availableApis.resolve(availableApis, config.routes.getPoints),
        getActivity: availableApis.resolve(availableApis, config.routes.getActivity),
        getReward: availableApis.resolve(availableApis, config.routes.getReward),
        getCoupons: availableApis.resolve(availableApis, config.routes.getCoupons),
        getPromotions: availableApis.resolve(availableApis, config.routes.getPromotions),
        getPlayerPromotions: availableApis.resolve(availableApis, config.routes.getPlayerPromotions),
        getPlayerPFDTransactions: availableApis.resolve(availableApis, config.routes.getPlayerPFDTransactions),
        getLotteryPromotions: availableApis.resolve(availableApis, config.routes.getLotteryPromotions),
        redeemPFDPoints: availableApis.resolve(availableApis, config.routes.redeemPFDPoints),
        getPointsForDrawings: availableApis.resolve(availableApis, config.routes.getPointsForDrawings),
        getNotifications: availableApis.resolve(availableApis, config.routes.getNotifications),
        dismissAllNotifications: availableApis.resolve(availableApis, config.routes.dismissAllNotifications),
        dismissNotification: availableApis.resolve(availableApis, config.routes.dismissNotification),
        getSweeps: availableApis.resolve(availableApis, config.routes.getSweeps),
        getSweepsByName: availableApis.resolve(availableApis, config.routes.getSweepsByName),
        getActiveSweeps: availableApis.resolve(availableApis, config.routes.getActiveSweeps),
        getCurrentSweeps: availableApis.resolve(availableApis, config.routes.getCurrentSweeps),
        getExpiredSweeps: availableApis.resolve(availableApis, config.routes.getExpiredSweeps),
        getSweepDetails: availableApis.resolve(availableApis, config.routes.getSweepDetails),
        getSweepDetailsByName: availableApis.resolve(availableApis, config.routes.getSweepDetailsByName),
        allocateEntries: availableApis.resolve(availableApis, config.routes.allocateEntries),
        getConfig: availableApis.resolve(availableApis, config.routes.getConfig),
        getRevealToken: availableApis.resolve(availableApis, config.routes.getRevealToken),
        getJackpotRoll: availableApis.resolve(availableApis, config.routes.getJackpotRoll),
        getAppVals: availableApis.resolve(availableApis, config.routes.getAppVals),
        getBanner: availableApis.resolve(availableApis, config.routes.getBanner),
        expiredDrawings: availableApis.resolve(availableApis, config.routes.expiredDrawings),
        recentDrawings: availableApis.resolve(availableApis, config.routes.recentDrawings),
        currentDrawings: availableApis.resolve(availableApis, config.routes.currentDrawings),
        nextDrawings: availableApis.resolve(availableApis, config.routes.nextDrawings),
        getAllOptins: availableApis.resolve(availableApis, config.routes.getAllOptins),
        getOptinsByCategory: availableApis.resolve(availableApis, config.routes.getOptinsByCategory),
        getOptins: availableApis.resolve(availableApis, config.routes.getOptins),
        optinSubscribe: availableApis.resolve(availableApis, config.routes.optinSubscribe),
        optinUnsubscribe: availableApis.resolve(availableApis, config.routes.optinUnsubscribe),
        sendRafInvite: availableApis.resolve(availableApis, config.routes.sendRafInvite),
        getRafCode: availableApis.resolve(availableApis, config.routes.getRafCode),
        getActiveSurveys: availableApis.resolve(availableApis, config.routes.getActiveSurveys),
        getSurveyStatus: availableApis.resolve(availableApis, config.routes.getSurveyStatus),
        getSurveyQuestions: availableApis.resolve(availableApis, config.routes.getSurveyQuestions),
        getNamedSurveyQuestions: availableApis.resolve(availableApis, config.routes.getNamedSurveyQuestions),
        setSurveyAnswer: availableApis.resolve(availableApis, config.routes.setSurveyAnswer),
        completeSurvey: availableApis.resolve(availableApis, config.routes.completeSurvey),
        getDashboard: availableApis.resolve(availableApis, config.routes.getDashboard),
        submitSocialMediaClick: availableApis.resolve(availableApis, config.routes.submitSocialMediaClick),
        completeCustomUrlQualifier: availableApis.resolve(availableApis, config.routes.completeCustomUrlQualifier),
        claimPromo: availableApis.resolve(availableApis, config.routes.claimPromo),
        getPlayerAllocatableEntries: availableApis.resolve(availableApis, config.routes.getPlayerAllocatableEntries),
        getPlayerPrizes: availableApis.resolve(availableApis, config.routes.getPlayerPrizes),
        getPlayerWinnings: availableApis.resolve(availableApis, config.routes.getPlayerWinnings),
        deletePlayerAccount: availableApis.resolve(availableApis, config.routes.deletePlayerAccount),
        getPointsHistory: availableApis.resolve(availableApis, config.routes.getPointsHistory),
        actionComplete: availableApis.resolve(availableApis, config.routes.actionComplete),
        callExternalEndpoint: availableApis.resolve(availableApis, config.routes.callExternalEndpoint),
        getThirdPartyPrizes: availableApis.resolve(availableApis, config.routes.getThirdPartyPrizes),
        getThirdPartyPrizeBarcode: availableApis.resolve(availableApis, config.routes.getThirdPartyPrizeBarcode),
        getTicketActivity: availableApis.resolve(availableApis, config.routes.getTicketActivity),
        updateEmail: availableApis.resolve(availableApis, config.routes.updateEmail),
        updatePassword: availableApis.resolve(availableApis, config.routes.updatePassword),
        updateOptins: availableApis.resolve(availableApis, config.routes.updateOptins),
        getGameEngineGameBoards: availableApis.resolve(availableApis, config.routes.getGameEngineGameBoards),
        getGameEngineGameBoard: availableApis.resolve(availableApis, config.routes.getGameEngineGameBoard),
        getGameEngineGameWinTypesWithPrizes: availableApis.resolve(availableApis, config.routes.getGameEngineGameWinTypesWithPrizes),
    };
};
